export default "__VITE_ASSET__JXkqEkTT__"